import React from 'react'

const AdditionsIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Outer House Structure */}
      <path d="M61.67,62.82H2.33v-33L32,.36,61.67,29.77Zm-55.34-4H57.67V31.43L32,6,6.33,31.43Z" />

      {/* Doorway / Entrance */}
      <path d="M40.56,62.82H23.44V46.28H40.56Zm-13.12-4h9.12V50.28H27.44Z" />

      {/* Addition / Plus Circle Symbol */}
      <path d="M32,42.61A13.72,13.72,0,1,1,45.72,28.9,13.73,13.73,0,0,1,32,42.61Zm0-23.43a9.72,9.72,0,1,0,9.72,9.72A9.73,9.73,0,0,0,32,19.18Z" />

      {/* Vertical Plus Bar */}
      <rect x="30" y="23.25" width="4" height="11.4" />

      {/* Horizontal Plus Bar */}
      <rect x="26.3" y="26.95" width="11.39" height="4" />
    </svg>
  )
}

export default AdditionsIcon
